/* eslint-disable react/require-default-props */
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import useTourViewerKrpano from '../hook/Krpano/useTourViewerKrpano'

/**
 * This component is a part of the tour viewer page.
 * It handles the panorama viewer part of the page.
 * It gets the point detail from the API and sets the initial properties of the Krpano viewer.
 * It also handles the case when the user selects a different point.
 */
interface TourViewerPanoramaProps {
  onLoad?: () => void
}

// eslint-disable-next-line react/function-component-definition
export default function TourViewerPanorama({
  onLoad = () => {}
}: TourViewerPanoramaProps) {
  const { setCurrentViewer } = useTourViewerKrpano()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams] = useSearchParams()

  useEffect(() => {
    ;(window as any).setKrpanoLoadingStatus = (status: any) => {
      const normalized = status === true || status === 'true'
      if (!normalized) {
        setTimeout(() => {
          setCurrentViewer((prev) => ({
            ...prev,
            imageIsLoading: normalized
          }))
          // The panorama is no longer loading, call onLoad
          onLoad?.()
        }, 700)
      } else {
        setCurrentViewer((prev) => ({
          ...prev,
          imageIsLoading: normalized
        }))
      }
    }

    return () => {
      delete (window as any).setKrpanoLoadingStatus
    }
  }, [setCurrentViewer, onLoad])

  // The point detail fetch and embedpano call are now handled centrally
  // by the useTourViewerKrpano hook to avoid redundant calls and race conditions.

  return <div id="viewer-pano-container" className="w-full h-full" />
}
